// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tab-item[data-v-1ecabe88]{border-bottom:1px solid #757575}.tab-item--active[data-v-1ecabe88]{border-bottom:none;border-left:1px solid #757575;border-right:1px solid #757575;border-top:1px solid #757575}.content-border[data-v-1ecabe88]{border:1px solid #757575;border-top:none;border-radius:0}", ""]);
// Exports
module.exports = exports;
